/* unplugin-vue-components disabled */import { render } from "./KilaKilaCommentItem.vue?vue&type=template&id=5adcc4d2&scoped=true"
import script from "./KilaKilaCommentItem.vue?vue&type=script&lang=js"
export * from "./KilaKilaCommentItem.vue?vue&type=script&lang=js"

import "./KilaKilaCommentItem.vue?vue&type=style&index=0&id=5adcc4d2&lang=less&scoped=true"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adcc4d2"]])

export default __exports__